import React, { Component } from 'react'
import Select, { Creatable } from 'react-select-plus'
import { ToolTip, Paginator, Button } from '@driftt/tide-core-legacy'
import InviteUserWizardModal from 'components/InviteUserWizardModal'
import AddButton from 'components/Integration/components/AddButton/index'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'
import { SFDCUserMapping } from 'app/modules/sfdc/models'
import SFDCAutomapModal from 'components/SFDC/SFDCAutomapModal'

import './style.styl'

class SalesforceUserMapping extends Component {

  constructor(props) {
    super(props)

    this.state = {
      mappings: props.sfdcUserMappings,
      sfdcUsers: props.sfdcUsers,
      showInviteModal: false,
      pendingInvites: null,
      invitedIndex: null,
      waitingForInvitedUsers: false,
      hasActiveSearch: null, 
      index: 0,
      totalPages: 0,
      size: 25
    }
  }

  componentWillReceiveProps(nextProps) {
    const { sfdcUserMappings, sfdcUsers, users } = this.props
    const { waitingForInvitedUsers, pendingInvites, invitedIndex } = this.state

    if (!_.isEqual(sfdcUserMappings, nextProps.sfdcUserMappings)) {
           this.setState({
        mappings: nextProps.sfdcUserMappings
      }, this.onMappingsChange)
    }

    if (!_.isEqual(sfdcUsers, nextProps.sfdcUsers)) {
      this.setState({
        sfdcUsers: nextProps.sfdcUsers
      })
    }

    if (waitingForInvitedUsers) {
      const pendingUser = Object.values(users).filter(user => user.email === pendingInvites[0])
      if (!pendingUser.length) {
        this.props.actions.fetchOrgUsers()
      } else {
        this.saveDriftUserOption({ value: pendingUser[0].id }, invitedIndex)
        this.setState({
          pendingInvites: null,
          invitedIndex: null,
          waitingForInvitedUsers: false,
        })
      }
    }
  }

  componentDidMount() {
    this.props.actions.fetchSFDCUserMappings()
    this.onMappingsChange()
  }

  isValid = () => {
    if (!this.state.mappings.length) return false
    let isValid = true

    this.state.mappings.forEach(mapping => {
      if (!mapping.salesforceId || !mapping.userId) {
        isValid = false
      }
    })

    return isValid
  }

  onMappingsChange = () => {
    const isValid = this.isValid()
    const { mappings, size, index } = this.state
    const { sfdcUserMappings } = this.props

    if (!mappings.length) this.addNewMapping()

    if (isValid) {
      if (sfdcUserMappings.length < mappings.length) {
        this.saveNewMappings()
      } else if (sfdcUserMappings.length === mappings.length) {
        this.saveChangedMapping()
      } else { // removed a mapping
        this.saveDeleteMappings()
      }
    }
    this.setState({
      totalPages: Math.ceil(mappings.length / size),
      index: index * size >= mappings.length ? Math.max(0, Math.ceil(mappings.length / size) - 1) : index
    })
    this.props.onChange({
      isValid: isValid
    })
  }

  getSalesforceUserOptions(id) {
    const mappedIds = this.state.mappings
      .map(mapping => mapping.salesforceId)
      .filter(sfId => sfId !== id)

    return this.state.sfdcUsers
      .filter(user => !mappedIds.includes(user.id))
      .map(user => {
        return { label: user.name, value: user.id }
      })
  }

  getFormattedUserOptions() {
    return Object.values(this.props.users).map(user => {
      return { value: user.id, label: getDisplayName(user) }
    })
  }

  searchSFDCUsers = (query, index) => {
    this.setState({
      hasActiveSearch: query.length ? index : null
    })

    !!query.length && this.debouncedSearch(query)

    return query
  }

  debouncedSearch = _.debounce(query => {
    this.props.actions.searchSFDCUsers(query)
  }, 500)

  addNewMapping = () => {
    this.setState(prevState => (
      {
        mappings: [...prevState.mappings, Object.assign({}, SFDCUserMapping)],
        index: Math.ceil((prevState.mappings.length + 1) / prevState.size) - 1
      }
    ), this.onMappingsChange)
  }

  removeMapping = (index) => {
    this.setState(prevState => {
      const updatedMappings = [...prevState.mappings]
      updatedMappings.splice(index + prevState.size * prevState.index, 1)

      return { 
        mappings: updatedMappings
      }
    }, this.onMappingsChange)
  }

  saveSalesforceOption(value, index) {
    this.setState(prevState => {
      const newMappings = [...prevState.mappings]
      newMappings[index + prevState.index * prevState.size].salesforceId = value ? value.value : null
      return { 
        newMappings, 
        hasActiveSearch: null
      }
    }, this.onMappingsChange)
  }

  saveDriftUserOption(value, index) {
    this.setState(prevState => {
      const newMappings = [...prevState.mappings]
      newMappings[index + prevState.index * prevState.size].userId = value ? value.value : null
      return { newMappings }
    }, this.onMappingsChange)
  }

  saveNewMappings() {
    const { mappings } = this.state
    this.props.actions.patchSFDCUserMappings({ set: mappings })
  }

  saveChangedMapping() {
    const { mappings } = this.state
    const { sfdcUserMappings } = this.props

    const orig = sfdcUserMappings.map(JSON.stringify)
    const updated = mappings.map(JSON.stringify)

    // Length of list is the same so the item changed in place, find this index.
    let changedPos = -1
    for (let pos in orig) {
      if (orig[pos] !== updated[pos]) {
        changedPos = pos
        break
      }
    }

    if (changedPos >= 0) {
      this.props.actions.patchSFDCUserMappings({ remove: [sfdcUserMappings[changedPos]], set: [mappings[changedPos]] })
    } else {
      // Revert to delete behavior.
      this.saveDeleteMappings()
    }
  }

  saveDeleteMappings() {
    const { mappings } = this.state
    const { sfdcUserMappings } = this.props

    const mappingsToRemove = sfdcUserMappings
      .map(JSON.stringify)
      .filter(mapping => !mappings.map(JSON.stringify).includes(mapping))
      .map(JSON.parse)

    this.props.actions.patchSFDCUserMappings({ remove: mappingsToRemove })
  }

  closeAutomapModal = (refresh) => {
    this.setState({
      showAutomapModal: false
    })
    if (refresh) {
      // Reload latest mappings
      window.location.reload()
    }
  }

  openAutomapModal = () => {
    this.setState({
      showAutomapModal: true
    })
  }

  closeInviteModal = (invitedUsers) => {
    this.setState({
      showInviteModal: false,
      pendingInvites: invitedUsers || null,
      waitingForInvitedUsers: !!invitedUsers.length
    }, this.props.actions.fetchOrgUsers)
  }

  openInviteModal = (index) => {
    this.setState({
      showInviteModal: true,
      invitedIndex: index
    })
  }

  renderSelectOption({ label }) {
    return <span>{label}</span>
  }

  renderSalesforceLoader = (index) => {
    const shouldShow = (this.state.hasActiveSearch === index) && this.props.sfdcUserMappingLoading
    return <span className={shouldShow && 'inline-loading'}></span>
  }

  renderSalesforceDropdown(id, index, disabled) {
    const selectOptions = {
      disabled: disabled,
      placeholder: "Search Salesforce Users..",
      value: id,
      options: this.getSalesforceUserOptions(id),
      searchable: true,
      isOpen: this.state.hasActiveSearch === index,
      pageSize: 10,
      optionRenderer: this.renderSelectOption,
      arrowRenderer: () => this.renderSalesforceLoader(index),
      onBlur: () => this.setState({ hasActiveSearch: null }),
      onChange: value => this.saveSalesforceOption(value, index),
      onInputChange: query => this.searchSFDCUsers(query, index),
    }

    return (
      <Select {...selectOptions} />
    )
  }

  renderDriftUserDropdown(id, index, disabled) {
    const selectOptions = {
      disabled: disabled,
      value: id,
      pageSize: 10,
      searchable: true,
      placeholder: "Select Drift User..",
      options: this.getFormattedUserOptions(),
      optionRenderer: this.renderSelectOption,
      onChange: (value) => this.saveDriftUserOption(value, index),
      onNewOptionClick: () => this.openInviteModal(index),
      promptTextCreator: () => (
        <div className="select-invite-link">
          <p>Invite New Teammate</p>
        </div>
      ),
    }

    return (
      <Creatable {...selectOptions} />
    )
  }

  renderMappingRows(readOnly) {
    return this.state.mappings.slice(this.state.index * this.state.size, (this.state.index + 1) * this.state.size)
      .map((mapping, index) => {
        
        return (
          <tr key={index}>
            <td>{this.renderDriftUserDropdown(mapping.userId, index, readOnly)}</td>
            <td className="salesforce-user-mapping-table-seperator"><div /></td>
            <td className="salesforce-user-mapping-salesforce-user">{this.renderSalesforceDropdown(mapping.salesforceId, index, readOnly)}</td>
            {!readOnly &&
              <td className="salesforce-user-mapping-actions">
                <Button 
                  type="utility" 
                  size="medium" 
                  icon="cancel-circle" 
                  className="salesforce-auto-mapping-button medium" 
                  onClick={() => this.removeMapping(index)}
                />
              </td>}
          </tr>
        )
      })
  }

  render() {
    const { readOnly } = this.props
    const { showInviteModal, showAutomapModal } = this.state

    return (
      <div>
        <div className="salesforce-user-mapping">
          {
            showAutomapModal &&
            <SFDCAutomapModal
              isOpen={showAutomapModal}
              onClose={this.closeAutomapModal}
            />
          }
          {
            showInviteModal &&
            <InviteUserWizardModal
              onClose={this.closeInviteModal}
              successCtaCopy="Back to Mappings"
            />
          }

          <table className="drift-table">
            <thead>
              <tr>
                <td>Drift Teammate</td>
                <td className="salesforce-user-mapping-actions"></td>
                <td>Salesforce User</td>
                <td className="salesforce-user-mapping-table-seperator"></td>
              </tr>
            </thead>
            <tbody>
              {this.renderMappingRows(readOnly)}
            </tbody>
          </table>
          <Paginator
           index={this.state.index}
           size={this.state.size}
           totalPages={this.state.totalPages}
           position="static"
           goForward={() => this.setState({ ...this.state, index: this.state.index + 1 })}
           goBackward={() => this.setState({ ...this.state, index: this.state.index - 1 })}
           changeSize={event => this.setState({ 
             ...this.state, 
             index: 0, 
             size: event.value, 
             totalPages: Math.ceil(this.state.mappings.length / event.value)
            })}
          />
          {!readOnly &&
            <AddButton
              addButtonLabel="Map another Salesforce user"
              type="tertiary"
              onClick={this.addNewMapping}
            />}

        </div>
        <div className="salesforce-auto-mapping-area">
          <ToolTip className='salesforce-auto-mapping-centered-text' component={<span >We will show you all your Salesforce and Drift<br/>users with the same email and name <br/>so you can instantly map them!</span>} flow='up'>
          <Button type="secondary" className="salesforce-auto-mapping-button secondary medium" onClick={this.openAutomapModal}>
              Automatically map users
            </Button>
          </ToolTip>
          <br/>
        </div>
      </div>
    )
  }
}

export default SalesforceUserMapping



// WEBPACK FOOTER //
// ./src/scripts/components/SFDC/UserMapping/index.js